/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Point_3Inputs */

const en_guestlist_point_3 = /** @type {(inputs: Guestlist_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relationship health for every account and brand`)
};

/**
* | output |
* | --- |
* | "Relationship health for every account and brand" |
*
* @param {Guestlist_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_point_3 = /** @type {((inputs?: Guestlist_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_point_3(inputs)
});